import Vue from 'vue'
import VueResource from 'vue-resource';
import { Endpoints } from './endpoints'
import { removeDuplicates } from './helpers'

Vue.use(VueResource);

export const Api = {

  get: function(store, name) {
    return this.request(store, name, "get");
  },

  post: function(store, name) {
    return this.request(store, name, "post");
  },

  put: function(store, name) {
    return this.request(store, name, "put");
  },

  request: function(store, name, method) {
    const self     = this;
    const state    = store.state;
    const endpoint = Endpoints.get(name, state);

    console.log(`Requesting via ${method}:`, name);

    return new Promise(function(resolve) {
      const requestParameters = {
        method: method,
        url: endpoint.url,
        params: endpoint.params,
        body: endpoint.body
      };

      Vue.http(requestParameters)
      .then(function(response) {
        if(this.handlers[name] === undefined) {
          this.handlers.default(store, name, response.data);
        } else {
          this.handlers[name](store, name, response.data);
        }
        resolve(response.data);
      }.bind(this), function(response) {
        console.log(response);
      });
    }.bind(this));
  },

  handlers: {
    default: function(store, name, data) {
      store.commit("updateOptions", { name: name, options: data });
    },
    year: function(store, name, data) {
      let options = [];

      data.range.reverse().forEach(item => {
        options.push({id: item, name: item});
      })

      store.commit("updateOptions", { name, options });
    },
    power: function(store, name, data) {
      let options = [];
      data.sort(function(a,b) { return a.power - b.power }).forEach(function(element) {
        var name = element.label.split(" - ")[1];
        options.push({ id: element.power, name: name });
      });
      options = removeDuplicates(options, "id");
      store.commit("updateOptions", { name, options });
    },
    engine: function(store, name, data) {
      let options = [];
      data.forEach(function(element) {
        if(element.power == store.state.selected.power) {
          options.push({ id: element.engine, name: element.label.split(" - ")[0] });
        }
      })
      store.commit("updateOptions", { name, options });
    },
    equipment: function(store, name, data) {
      let options = [];
      data.forEach(function(element) {
        options.push({ id: element, name: element });
      });
      if(options.length == 0) { options.push({id: "-1", name: "Basis"})}
      store.commit("updateOptions", { name, options });
    },
    extras: function(store, name, data) {
      let options = [];
      store.commit("updateSelected", {name: "schwacke", value: data.id});
      if(data.extras) {
        Object.keys(data.extras).forEach(function(key) {
          options.push({ id: data.extras[key].id, name: data.extras[key].label, checked: data.extras[key].checked });
          if(data.extras[key].checked) {
            store.commit("toggleOption", {name: "extras", value: data.extras[key].id});
          }
        })
      }
      store.commit("updateOptions", { name, options });
    },
    valuation: function(store, name, data) {
      var extras = []
      if(data['extras']) {
        extras = Object.keys(data['extras']).map(function(key) {
          return data['extras'][key]['id'];
        });
      }
      const valuationData = Object.assign({}, data, {extras});
      store.commit("updateSelected", { name: "valuation", value: valuationData });
    },
    createLead: function(store, name, data) {
      store.commit("updateToken", { token: data.token });
    },
    getLead: function(store, name, data) {
      store.commit("updateLead", { lead: data });
    },
    updateFeedback: function(store, name, data) {
      store.commit("updateLead", { lead: data });
    },
    redirect: function(store, name, data) { console.log("REDIRECT RES", data)}
  },
}



// WEBPACK FOOTER //
// ./src/services/api.js